import React, { useState, useCallback } from 'react';
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

export function useToast() {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = 'success') => {
    setToast({ message, type, key: Date.now() });
    setTimeout(() => setToast(null), 3500);
  }, []);

  return { toast, setToast, showToast };
}

export default function Toast({ toast, onClose }) {
  if (!toast) return null;

  return (
    <div
      key={toast.key}
      className="fixed top-6 right-6 z-[100] max-w-sm w-full pointer-events-auto animate-toast-in"
    >
      <div className={`flex items-start gap-3 px-5 py-4 rounded-xl shadow-2xl border backdrop-blur-sm ${
        toast.type === 'success'
          ? 'bg-green-50 border-green-200 text-green-800'
          : 'bg-red-50 border-red-200 text-red-800'
      }`}>
        {toast.type === 'success' ? (
          <CheckCircleIcon className="h-6 w-6 text-green-500 flex-shrink-0 mt-0.5" />
        ) : (
          <ExclamationTriangleIcon className="h-6 w-6 text-red-500 flex-shrink-0 mt-0.5" />
        )}
        <p className="text-sm font-medium flex-1">{toast.message}</p>
        <button
          onClick={onClose}
          className={`flex-shrink-0 p-0.5 rounded-full transition-colors ${
            toast.type === 'success' ? 'hover:bg-green-200' : 'hover:bg-red-200'
          }`}
        >
          <XMarkIcon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
